module.exports = __webpack_public_path__ + "static/media/Creative Brief - Speaker Intro_1654533232565.c7fcd8e1.docx";